import { DsArea } from '@nkr/enums/index';

export function isAdvancedDsArea(area: DsArea): boolean {
    return area === DsArea.Advanced;
}

export {
    seedAdvReimburseEnabledCenters,
    getAdvReimburseEnabledCenterIds,
    isAdvReimburseEnabledCentersLoaded,
    isAdvReimburseEnabledForCenter,
    isAdvReimburseEligibleOrgan,
    canShowAdvReimburseAction,
} from './adv-reimburse-enabled-centers';
